import { render, staticRenderFns } from "./detailComplete.vue?vue&type=template&id=c97460a8&"
import script from "./detailComplete.vue?vue&type=script&lang=js&"
export * from "./detailComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports